import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderInteger,
  renderDropdown,
  renderCheckBox,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
  RenderRadio,
} from "./RenderUtils";

export class AddHnoaToGlBopRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          {renderCheckBox(
            "isCommercialAutoPolicyInForce",
            "Commercial Auto Policy in Force",
            request,
            updateRequest
          )}
          {renderInteger(
            "personalAutoEmployeesNumber",
            "Number of employees that regularly (more that three times a week) use the personal autos as part of their job",
            request,
            updateRequest,
            "e.g. 5"
          )}
          {renderDropdown(
            "maximumRadiusOfOperation",
            "Maximum Radius of Operation",
            request,
            updateRequest,
            this.props.maximumRadiusesOfOperations
          )}
          <RenderRadio
            name="How are hired or rental vehicles used?"
            options={[
              {
                Name: "Limited to occasional use of rental cars for out of town travel",
                Value:
                  "Limited to occasional use of rental cars for out of town travel",
              },
              {
                Name: "Other",
                Value: "Other",
              },
            ]}
            request={request}
            requestPropertyName="howAreHiredOrRentalVehiclesUsed"
            updateRequestPropertyCallBack={updateRequest}
          />
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
